/**
 * Central Management > 객체 >
 *  APT >> APT 프로파일 store
 *
 * @since 2020-04-10
 * @author tams_dev2
 */

import {base64Encode} from '~/utils/base64'
import {ObjectSecProfileApiPrefix as opApiPrefix} from '~/utils/restApi'

const urlPrefix = `${opApiPrefix}/cmn-settings`
const aptCmnEmptyInfoData = () => {
  return {
    apt_cmn_id: null, // "(integer)(not null) APT공통설정 통합설정 ID",
    apt_cmn_sync_yn: 1, // "(integer)(not null)(Define=0,1) APT공통설정 통합설정 동기화 여부",
    apt_cmn_uname: '', // "(string)(not null)(range=1-32) 객체명",
    apt_cmn_desc: '', // "(string)(range=0-128) 설명",
    // device_id_list: [], // "(list-integer) 대상 장비 ID 리스트",
    device_list: [
      // {
      //   device_id: 1,
      //   device_name: ''
      // }
    ],
    apt_svr_sync_yn: 1, // "(integer) 클라우드 수집 동기화 여부 사용 안함: 0, 사용: 1",
    apt_svr_type: 1, // "(integer)(not null)(Define=1,2,) 분석장비 타입 클라우드: 1, MBAS: 2",
    apt_svr_ip_type: 1, // "(integer)(not null)(Define=1,2,) MBAS IP 버전 IPv4: 1, IPv6: 2",
    apt_svr_ip: '0.0.0.0', // "(string)(not null) 분석 장비 IP 주소 svr_ip_type가 1일 때 v4 IP svr_ip_type가 2일 때 v6 IP",
    apt_cld_sync_yn: 1, // "(integer)(not null)(Define=0,1,) 클라우드 수집 동기화 여부 사용 안함: 0, 사용: 1",
    apt_cld_agree: 0, // "(integer)(not null)(Define=0,1,) 클라우드 수집 동의 여부 사용 안함: 0, 사용: 1",
    apt_cld_snd_type: 1, // "(integer)(not null)(Define=0,1,) 클라우드 전송 유형 파일: 0, 해시: 1",
    apt_cnc_block_sync_yn: 1, // "(integer)(not null)(Define=0,1,) C&C 차단 설정 동기화 여부 사용 안함: 0, 사용: 1",
    apt_cnc_block_use: 0, // "(integer)(not null)(Define=0,1,) C&C 차단 설정 사용 여부 사용 안함: 0, 사용: 1",
    apt_cnc_block_hour: 1, // "(integer)(not null) C&C 차단 설정 차단 시간",
    apt_hrst_sync_yn: 1, // "(integer)(not null) 휴리스틱 설정 탐지 동기화 여부 사용 안함: 0, 사용: 1",
    apt_hrst_detect_score: 300, // "(integer)(not null) 휴리스틱 설정 탐지 점수",
    apt_hrst_block_hour: 1, // "(integer)(not null) 휴리스틱 설정 차단 시간",
    apt_excpt_sync_yn: 1, // "(integer)(not null)(Define=0,1,) APT 예외 프로파일 동기화 여부 사용 안함: 0, 사용: 1",
    apt_excpt_list: {
      // id: null, // "(integer) APT 예외 프로파일 ID",
      // name: '' // "(string) APT 예외 프로파일 이름"
    },
    apt_excpt_list_id: null, // "(integer) APT 예외 프로파일 ID",

    mbas_key: null,
    gc_sleep_term: null,
    report_sleep_term: null,
    white_cache_expire_tm: null,
    black_cache_expire_tm: null,
    hit_stat_term: null,
    hit_snd_cnt: null,
    ht_exp_time: null,
    cache_exp_time: null,
    conn_timeout_p: null,
    recv_timeout_p: null,
    unlink_file_term: null,
    device_list_name: ''
  }
}
export const state = () => ({
  aptCmnLastId: 0,
  aptExpLastId: 1,
  aptObjLastId: 1,
  cmnKey: 'apt_cmn_id',
  listKey: 'apt_excpt_list_id',
  objKey: 'apt_data_obj_id',
  cloudAgreement: '',
  cmnApi: { // APT 공통/예외 설정
    url: `${opApiPrefix}/apt/cmn-settings`,
    config: {
      loading: false,
      successAlert: false
    }
  },
  aptCmnList: [],
  aptCmnInfo: {},
  aptCmnEmptyInfo: aptCmnEmptyInfoData(),
  expApi: { // APT 예외 프로파일
    url: `${opApiPrefix}/apt/exceptions`,
    config: {
      loading: false,
      successAlert: false
    }
  },
  aptExcptList: [],
  aptExcptInfo: {
    apt_cmn_id: 0, // "(integer) APT공통설정 통합설정 ID",
    apt_excpt_list_id: 0, // "(integer) 예외 프로파일 ID",
    apt_excpt_list_use: 0, // "(integer)(not null)(Define=0,1) 사용 여부 사용 안함: 0, 사용: 1",
    apt_excpt_list_uname: '', // "(string)(not null)(range=1-32) 프로파일 이름",
    apt_excpt_list_desc: '' // "(string)(range=0-128) 설명"
  },
  aptExpItemList: [
    // {
    //   apt_cmn_id: 0,
    //   apt_excpt_list_id: null,
    //   apt_data_obj_id: null,
    //   apt_excpt_list_uname: '',
    //   apt_excpt_list_use: 0,
    //   http_use: 0,
    //   smtp_use: 0,
    //   pop3_use: 0,
    //   ftp_use: 0,
    //   imap_use: 0
    // }
  ],
  aptExpItems: {
    apt_cmn_id: 0, // "(integer)(not null) APT공통설정 통합설정 ID",
    apt_excpt_list_id: null, // "(integer) 예외 프로파일 ID",
    apt_data_obj_id: null, // "(integer) 예외 객체 ID",
    apt_excpt_list_uname: '', // "(string) 예외 객체 명",
    apt_excpt_list_use: 0, // "(integer) 사용 여부 사용 안함: 0, 사용: 1",
    http_use: 0, // "(integer) HTTP 프로토콜 사용 여부 사용 안함: 0, 사용: 1",
    smtp_use: 0, // "(integer) SMTP 프로토콜 사용 여부 사용 안함: 0, 사용: 1",
    pop3_use: 0, // "(integer) POP3 프로토콜 사용 여부 사용 안함: 0, 사용: 1",
    ftp_use: 0, // "(integer) FTP 프로토콜 사용 여부 사용 안함: 0, 사용: 1",
    imap_use: 0 // "(integer) IMAP 프로토콜 사용 여부 사용 안함: 0, 사용: 1"
  },
  objApi: { // APT 예외 객체
    url: `${opApiPrefix}/apt/data/objects`,
    config: {
      loading: false,
      successAlert: false
    }
  },
  aptObjList: void 0,
  aptObjInfo: {
    apt_data_obj_id: null, // "(integer)(not null) 예외 객체 ID",
    apt_data_obj_uname: '', // "(string)(not null)(range=1-32) 객체명",
    apt_data_obj_use: 0, // "(integer)(not null)(Define=0,1) 사용 여부 사용 안함: 0, 사용: 1",
    apt_data_obj_value_type: 0, // "(integer)(not null)(Define=0,1) 데이터 유형 문자열: 0, 정규 표현식:1",
    apt_data_obj_value: '', // "(string)(not null)(range=1-25) 데이터 값 Base64 인코딩된 값",
    apt_data_obj_desc: '' // "(string)(range=0-128) 설명"
  },
  clearExceptModel: { // APT 프로파일 초기화 데이터
    apt_cmn_id: null,
    apt_excpt_list_id: 1,
    apt_excpt_list_use: 0,
    apt_excpt_list_uname: null,
    apt_excpt_list_desc: ''
  },
  clearObjectModel: {
    apt_data_obj_id: null,
    apt_data_obj_use: 0,
    apt_data_obj_name: '',
    apt_data_obj_value_type: 0,
    apt_data_obj_value: '',
    apt_data_obj_desc: ''
  }
})

export const mutations = {
  setAptCloudAgreement: (state, data) => {
    if (data.notice) {
      state.cloudAgreement = data.notice.split('\n').join('<br />')
    }
  },
  setAptObjList: (state, data) => {
    state.aptObjList = data
  },
  setAptDataObject: (state, data) => {
    if (_.includes(_.map(state.aptObjList, state.objKey), data[state.objKey])) {
      state.aptObjList = _.map(state.aptObjList, (item) => {
        return (item[state.objKey] === data[state.objKey]) ? data : item
      })
    } else {
      state.aptObjList.push(data)
      state.aptObjLastId++
    }
  },
  delAptDataObject: (state, data) => {
    state.aptObjList = _.filter(state.aptObjList, (v) => {
      return _.isNil(_.find(data, _.matchesProperty(state.objKey, v[state.objKey])))
    })
  }
}

export const actions = {
  // APT 설정 조회
  async getCloudAgreement ({commit}) {
    let {code, result} = await this.$axios.$get(`${opApiPrefix}/apt/cloud/collection/agreement`, {loading: false, successAlert: false})

    if (code === 'ok') {
      commit('setAptCloudAgreement', result)
      return {code}
    }
    return {code, result}
  },
  // APT 공통/예외 설정 목록 단일/다중 조회
  async getList ({commit, state}, cmnId = null) {
    const
      isMulti = _.isNil(cmnId),
      apiUrl = `${state.cmnApi.url}${(isMulti) ? '' : `/${cmnId}`}`,
      {code, result} = await this.$axios.$get(
        apiUrl,
        state.cmnApi.config
      )
    return {code, result}
  },
  // APT 공통 설정 [일괄 삭제/삭제]
  async delList ({commit, state}, [item, cmnId = null]) {
    const isMulti = _.size(item.items) > 1
    const apiUrl = `${state.cmnApi.url}`
    let param = []

    if (isMulti) {
      param = [
        apiUrl,
        _.assignIn({ data: item }, _.cloneDeep(state.cmnApi.config))
      ]
    } else {
      const id = _.isNil(cmnId) ? item.items[0][state.cmnKey] : cmnId
      param = [
        `${apiUrl}/${id}`,
        _.assignIn({ data: item.items[0] }, _.cloneDeep(state.cmnApi.config))
      ]
    }

    const {code, result} = await this.$axios.$delete(...param)

    return {code, result}
  },
  // APT 공통/에외 설정 (빈 설정) 추가
  async addList ({commit, state}) {
    const {code, result} = await this.$axios.$post(
      state.cmnApi.url,
      // {
      //   apt_cmn_sync_yn: 0,
      //   apt_cmn_uname: 'test',
      //   apt_cmn_desc: '',
      //   device_list: []
      // },
      null,
      state.cmnApi.config
    )

    return {code, result}
  },
  // APT 공통/예외 설정 목록 일괄 수정. - 동기화 여부 일괄 수정.
  async markedUseList ({commit, state}, item) {
    const {code, result} = await this.$axios.$put(state.cmnApi.url, item, {failAlert: false})
    return {code, result}
  },
  // APT 공통/예외 설정 수정.
  async setList ({commit, state}, [item, cmnId]) {
    const deviceIdList = _.map(item.device_list, 'device_id')
    item.device_id_list = deviceIdList
    const {code, result} = await this.$axios.$put(`${state.cmnApi.url}/${cmnId}`, item, state.cmnApi.config)
    return {code, result}
  },
  // APT 예외 프로파일 목록 단일/다중 조회
  async getProfile ({commit, state}, [cmnId, profId = null]) {
    try {
      const
        isInfo = !_.isNil(profId),
        apiUrl = `${state.expApi.url}/${cmnId}${(isInfo) ? `/${profId}` : ''}`,
        {code, result} = await this.$axios.$get(
          apiUrl,
          state.expApi.config
        )

      return {code, result}
    } catch (e) {
      this.$log('getProfile Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  async markedUseProfile ({commit, state}, [item, cmnId]) {
    const {code, result} = await this.$axios.$put(`${state.expApi.url}/${cmnId}`, item, {failAlert: true})
    return {code, result}
  },
  async markedUseProfileSub ({commit, state}, [item, cmnId, profId]) {
    const {code, result} = await this.$axios.$put(`${state.expApi.url}/${cmnId}/${profId}/items`, item, {failAlert: false})
    return {code, result}
  },
  // APT 예외 프로파일 추가/편집
  async setProfile ({commit, state}, [item, cmnId, profId = null]) {
    const
      param = _.clone(item),
      isAdd = _.isNil(profId),
      method = (isAdd) ? '$post' : '$put',
      url = `${state.expApi.url}/${cmnId}${(isAdd) ? '' : `/${profId}`}`
    // param.apt_data_obj_value = base64Encode(param.apt_data_obj_value)

    const {code, result} = await this.$axios[method](
      url,
      param,
      state.expApi.config
    )

    return {code, result}
  },
  async delProfile ({commit, state}, [item, cmnId, profId = null]) {
    const isMulti = _.size(item.items) > 1
    const apiUrl = `${state.expApi.url}/${cmnId}`
    let param = []

    if (isMulti) {
      param = [
        apiUrl,
        { data: item }
      ]
    } else {
      param = [
        `${apiUrl}/${profId}`,
        { data: item.items[0] }
      ]
    }

    const {code, result} = await this.$axios.$delete(
      ...param,
      state.expApi.config
    )

    return {code, result}
  },
  async getExpItems ({commit, state}, [cmnId, profId, objId = null]) {
    try {
      const
        isObj = !_.isNil(objId),
        apiUrl = `${state.expApi.url}/${cmnId}/${profId}/items${(isObj) ? `/${objId}` : ''}`,
        {code, result} = await this.$axios.$get(
          apiUrl,
          state.expApi.config
        )

      return {code, result}
    } catch (e) {
      this.$log('getExpItems Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  async addExp ({commit, state}, [item, cmnId, profId]) {
    try {
      const url = `${state.expApi.url}/${cmnId}/${profId}/items`
      const objIdList = _.map(item.apt_data_obj_list, state.objKey)
      const data = _.assign(item, _.zipObject([state.cmnKey, state.listKey], [cmnId, profId]))

      data.apt_data_obj_list = objIdList
      const {code, result} = await this.$axios.$post(
        url,
        data,
        state.expApi.config
      )

      return {code, result}
    } catch (e) {
      this.$log('addExp Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  async delExp ({commit, state}, [item, cmnId, profId]) {
    try {
      const
        url = `${state.expApi.url}/${cmnId}/${profId}/items`,
        // data = _.assign(item, _.zipObject([state.cmnKey], [cmnId]))
        {code, result} = await this.$axios.$delete(
          url,
          // item,
          { data: item },
          state.expApi.config
        )

      return {code, result}
    } catch (e) {
      this.$log('delExp Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // APT 예외 객체 조회 / 상세 조회
  async getAptDataObject ({commit, state}, [cmnId, objId = null]) {
    try {
      const
        isInfo = !_.isNil(objId),
        apiUrl = `${state.objApi.url}/${cmnId}${(isInfo) ? `/${objId}` : ''}`,
        {code, result} = await this.$axios.$get(
          apiUrl,
          state.objApi.config
        )
      if (code === 'ok' && !isInfo) {
        commit('setAptObjList', result)
      }
      if (_.isUndefined(state.aptObjList)) {
        commit('setAptObjList', [])
      }

      return {code, result}
    } catch (e) {
      this.$log('getAptDataObject Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // APT 예외 객체 일괄 수정. - 사용 여부 일괄 수정.
  async markedUseObject ({commit, state}, [item, cmnId]) {
    const {code, result} = await this.$axios.$put(`${state.objApi.url}/${cmnId}`, item, {failAlert: false})
    return {code, result}
  },
  // APT 예외 객체 추가/편집
  async setAptDataObject ({commit, state}, [item, cmnId, excpId = null]) {
    const
      param = _.clone(item),
      isAdd = _.isNil(excpId),
      method = (isAdd) ? '$post' : '$put',
      url = `${state.objApi.url}/${cmnId}${(isAdd) ? '' : `/${excpId}`}`

    param.apt_data_obj_value = base64Encode(param.apt_data_obj_value)

    const {code, result} = await this.$axios[method](
      url,
      param,
      {
        loading: false
      }
    )

    return {code, result}
  },
  async delAptDataObject ({commit, state}, [item, cmnId, excpId = null]) {
    try {
      const
        isMulti = (_.size(item.items) > 1) && _.isNil(excpId),
        apiUrl = `${state.objApi.url}/${cmnId}`,
        param = (isMulti) ? [
          apiUrl,
          { data: item }
        ] : [
          `${apiUrl}/${excpId}`,
          { data: item.items[0] }
        ],
        {code, result} = await this.$axios.$delete(
          ...param,
          state.objApi.config
        )

      return {code, result}
    } catch (e) {
      this.$log('delAptDataObject Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // APT 공통 설정 적용/취소
  async finalCommand ({commit, state}, {type, loadingShow = true}) {
    try {
      const param = _.assign({ loadingShow: loadingShow }, (_.eq(type, 'apply')) ? { applyMsg: true } : { cancelMsg: true })
      const {code, result} = await this.$axios.$put(`${urlPrefix}/${type}`, null, param)
      if (code !== 'ok') {
        return result.msg
      }
      return code
    } catch (e) {
      this.$log('[APT] finalCommand Exception -> ', e)
      return e
    }
  }
}

export const getters = {}

export const strict = false
